import React from 'react';
import { Alert, Box } from '@amzn/awsui-components-console';

export default function ProtectedRoute({ isProtected, children }) {
    if (isProtected) {
        console.debug('Protected');
        return <>{children}</>;
    } else {
        console.debug('Not protected');
        return <></>;
    }
}
